import { render, staticRenderFns } from "./vault-config.vue?vue&type=template&id=fe8f4558"
import script from "./vault-config.vue?vue&type=script&lang=js"
export * from "./vault-config.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports